// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo{max-width:100%;padding:20px}tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.03)}.v-application .v-card__title{word-break:normal}.field--type_id .v-input__icon--clear{display:none}.cruxtify-model-layout.model--mos-price .crud-model-layout-container>.container{max-width:100%}.cruxtify-model-layout.model--mos-price .crud-field-set.editmode .container>.row>.col{padding-bottom:0;padding-top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
